import React from 'react'

import { Box } from '@mui/material'
import CustomerAIContext from 'features/customers/components/details/CustomerAIContext'
import CustomerDetailsSummary from 'features/customers/components/details/CustomerDetailsSummary'

type CustomerDetailsProps = {
  customer?: Record<string, any>
}

// A container query, not a media query: the drawer changes how much room there actually is.
const CustomerDetails = ({ customer }: CustomerDetailsProps) => (
  <Box sx={{ containerType: 'inline-size' }}>
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: '1fr',
        alignItems: 'start',
        '@container (min-width: 1100px)': { gridTemplateColumns: 'repeat(2, 1fr)' },
      }}>
      <CustomerDetailsSummary customer={customer ?? {}} />
      <CustomerAIContext customer={customer} />
    </Box>
  </Box>
)

export default CustomerDetails
